import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Card, CardFooter, CardHeader, Container, Table, UncontrolledTooltip } from 'reactstrap'
import EhcReport from "models/Echreport.modal"



const Echlistdetail = () => {
  const [data, setdata]=useState();
const params = useParams();

  const list =async()=>{
    EhcReport.ListByClassIdStudentId(params?.id, params?.mid)
    .then((responce)=>{
      setdata(responce?.data);
    })
    .catch((error)=>{
      console.log("error",error)
    })
  }
  console.log("datattat-------------------y",data)
  useEffect(()=>{list();},[])
  return (
    <Container className="px-4 py-7">
       <div className="col mt-4">
            <Card className="shadow border">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0" style={{ color: "black" }}>
                  Ech Report deatail
                </h3>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr style={{ border: '1px solid black' }}>
                    <th rowSpan="2"style={{ border: '1px solid black' }}>S.No.</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>attendance_tracking</th> 
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>test report status</th> 
                    <th  colSpan="3"style={{ border: '1px solid black',backgroundColor:"lightgray"}}>concept_clarity</th>
                    <th  colSpan="3"style={{ border: '1px solid black',backgroundColor:"lightgray" }}>concept_of_understanding</th>
                    <th  colSpan="3"style={{ border: '1px solid black',backgroundColor:"lightgray"}}>presentation_skills</th>
                    <th  colSpan="3"style={{ border: '1px solid black',backgroundColor:"lightgray"}}>question_understanding</th>
                    <th  colSpan="3"style={{ border: '1px solid black' ,backgroundColor:"lightgray"}}>syllabus_coverage</th>
                    <th  colSpan="3"style={{ border: '1px solid black' ,backgroundColor:"lightgray"}}>time_management</th>
                    <th  colSpan="3"style={{ border: '1px solid black' ,backgroundColor:"lightgray"}}>tuition_copy_maintenance</th>
                    <th  colSpan="3"style={{ border: '1px solid black' ,backgroundColor:"lightgray"}}>presentation_skills</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>regularity_of_educator</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>self_studdy_time</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>weaker_areas</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>suggestion</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>feedback_complaints</th>
                    <th  colSpan="4"style={{ border: '1px solid black',backgroundColor:"lightgray"}}>Subject 1</th>
                    <th  colSpan="4"style={{ border: '1px solid black' ,backgroundColor:"lightgray"}}>Subject 2</th>
                    <th  colSpan="4"style={{ border: '1px solid black' ,backgroundColor:"lightgray"}}>Subject 3</th> 
                    <th  colSpan="4"style={{ border: '1px solid black',backgroundColor:"lightgray"}}>Subject 4</th> 
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>long_term</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>opportunities</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>short_term</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>strength</th>
                    <th  rowSpan="2"style={{ border: '1px solid black' }}>weakness</th>   
                    <th  colSpan="4" style={{ border: '1px solid black' }}>Answer Sheet </th>   
                    <th colSpan="5" style={{ border: '1px solid black' }}>Consultation </th>         
                    </tr>
                    <tr style={{ border: '1px solid black' }}>
                    <th style={{ border: '1px solid black' }}>Marks</th>
                    <th style={{ border: '1px solid black' }}>Total</th>
                    <th style={{ border: '1px solid black' }}>Remark</th>
                    <th style={{ border: '1px solid black' }}>Marks</th>
                    <th style={{ border: '1px solid black' }}>Total</th>
                    <th style={{ border: '1px solid black' }}>Remark</th>
                    <th style={{ border: '1px solid black' }}>Marks</th>
                    <th style={{ border: '1px solid black' }}>Total</th>
                    <th style={{ border: '1px solid black' }}>Remark</th>
                    <th style={{ border: '1px solid black' }}>Marks</th>
                    <th style={{ border: '1px solid black' }}>Total</th>
                    <th style={{ border: '1px solid black' }}>Remark</th>
                    <th style={{ border: '1px solid black' }}>Marks</th>
                    <th style={{ border: '1px solid black' }}>Total</th>
                    <th style={{ border: '1px solid black' }}>Remark</th>
                    <th style={{ border: '1px solid black' }}>Marks</th>
                    <th style={{ border: '1px solid black' }}>Total</th>
                    <th style={{ border: '1px solid black' }}>Remark</th>
                    <th style={{ border: '1px solid black' }}>Marks</th>
                    <th style={{ border: '1px solid black' }}>Total</th>
                    <th style={{ border: '1px solid black' }}>Remark</th>
                    <th style={{ border: '1px solid black' }}>Marks</th>
                    <th style={{ border: '1px solid black' }}>Total</th>
                    <th style={{ border: '1px solid black' }}>Remark</th>
                    <th style={{ border: '1px solid black' }}>Subject name</th>
                    <th style={{ border: '1px solid black' }}>Question</th>
                    <th style={{ border: '1px solid black' }}>Mark</th>
                    <th style={{ border: '1px solid black' }}>Total mark</th>
                    <th style={{ border: '1px solid black' }}>Subject name</th>
                    <th style={{ border: '1px solid black' }}>Question</th>
                    <th style={{ border: '1px solid black' }}>Mark</th>
                    <th style={{ border: '1px solid black' }}>Total mark</th>
                    <th style={{ border: '1px solid black' }}>Subject name</th>
                    <th style={{ border: '1px solid black' }}>Question</th>
                    <th style={{ border: '1px solid black' }}>Mark</th>
                    <th style={{ border: '1px solid black' }}>Total mark</th>
                    <th style={{ border: '1px solid black' }}>Subject name</th>
                    <th style={{ border: '1px solid black' }}>Question</th>
                    <th style={{ border: '1px solid black' }}>Mark</th>
                    <th style={{ border: '1px solid black' }}>Total mark</th>
                    <th style={{ border: '1px solid black' }}>Answer Sheet1</th>
                    <th style={{ border: '1px solid black' }}>Answer Sheet2</th>
                    <th style={{ border: '1px solid black' }}>Answer Sheet3</th>
                    <th style={{ border: '1px solid black' }}>Answer Sheet4</th>
                    <th style={{ border: '1px solid black' }}>Status</th>
                    <th style={{ border: '1px solid black' }}>Start Time</th>
                    <th style={{ border: '1px solid black' }}>End Time</th>
                    <th style={{ border: '1px solid black' }}>date</th>
                    <th style={{ border: '1px solid black' }}>link</th>
                   
                   
                    
                </tr>
                </thead>

               
                  <tbody>
                   
                  {data?.data?.map((item, index)=>{
                    console.log("OOO",item)
                    return(
                      <tr  style={{ cursor: "pointer" }} key={index}>
                      <td style={{ border: '1px solid black' }}>{index + 1}</td>
                      <td style={{ border: '1px solid black' }}>{item?.attendance_tracking
                      }</td>
                      <td style={{ border: '1px solid black' }} >{item?.test_report?.status}</td>
                      <td style={{ border: '1px solid black' }}>{item?.concept_clarity?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.concept_clarity?.total}</td>
                      <td style={{ border: '1px solid black' }}>{item?.concept_clarity?.remark}</td>
                      <td style={{ border: '1px solid black' }}>{item?.concept_of_understanding?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.concept_of_understanding?.total}</td>
                      <td style={{ border: '1px solid black' }}>{item?.concept_of_understanding?.remark}</td>
                      <td style={{ border: '1px solid black' }}>{item?.presentation_skills?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.presentation_skills?.total}</td>
                      <td style={{ border: '1px solid black' }}>{item?.presentation_skills?.remark}</td>
                      <td style={{ border: '1px solid black' }}>{item?.question_understanding?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.question_understanding?.total}</td>
                      <td style={{ border: '1px solid black' }}>{item?.question_understanding?.remark}</td>
                      <td style={{ border: '1px solid black' }}>{item?.syllabus_coverage?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.syllabus_coverage?.total}</td>
                      <td style={{ border: '1px solid black' }}>{item?.syllabus_coverage?.remark}</td>
                      <td style={{ border: '1px solid black' }}>{item?.time_management?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.time_management?.total}</td>
                      <td style={{ border: '1px solid black' }}>{item?.time_management?.remark}</td>
                      <td style={{ border: '1px solid black' }}>{item?.tuition_copy_maintenance?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.tuition_copy_maintenance?.total}</td>
                      <td style={{ border: '1px solid black' }}>{item?.tuition_copy_maintenance?.remark}</td>
                      <td style={{ border: '1px solid black' }}>{item?.presentation_skills?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.presentation_skills?.total}</td>
                      <td style={{ border: '1px solid black' }}>{item?.presentation_skills?.remark}</td>
                      <td style={{ border: '1px solid black' }}>{item?.regularity_of_educator}</td>
                      <td style={{ border: '1px solid black' }}>{item?.self_studdy_time}</td>
                      <td style={{ border: '1px solid black' }}>{item?.weaker_areas}</td>
                      <td style={{ border: '1px solid black' }}>{item?.	suggestion}</td>
                      <td style={{ border: '1px solid black' }}>{item?.feedback_complaints}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_1?.subject_name}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_1?.question}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_1?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_1?.total_marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_2?.subject_name}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_2?.question}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_2?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_2?.total_marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_3?.subject_name}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_3?.question}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_3?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_3?.total_marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_4?.subject_name}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_4?.question}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_4?.marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.subject_4?.total_marks}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.long_term}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.opportunities}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.short_term}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.strength}</td>
                      <td style={{ border: '1px solid black' }}>{item?.swot_report?.weakness}</td>
                      <td style={{ border: '1px solid black' }} onClick={()=>{
                        window.open(item?.sheet_1?.link, '_blank');
                      }}>{item?.sheet_1?.link}</td>
                      <td style={{ border: '1px solid black' }}
                      onClick={()=>{
                        window.open(item?.sheet_2?.link, '_blank');
                      }}>{item?.sheet_2?.link}</td>
                      <td style={{ border: '1px solid black' }}
                      onClick={()=>{
                        window.open(item?.sheet_3?.link, '_blank');
                      }}>{item?.sheet_3?.link}</td>
                      <td style={{ border: '1px solid black' }}
                      onClick={()=>{
                        window.open(item?.sheet_4?.link, '_blank');
                      }}>{item?.sheet_4?.link}</td>

<td style={{ border: '1px solid black' }}>{item?.consultation_data?.status}</td>
<td style={{ border: '1px solid black' }}>{item?.consultation_data?.start_time}</td>
<td style={{ border: '1px solid black' }}>{item?.consultation_data?.end_time}</td>
<td style={{ border: '1px solid black' }}>{item?.consultation_data?.date}</td>
<td style={{ border: '1px solid black' }} ><span
onClick={()=>{
  window.open(item?.consultation_data?.meeting_link, '_blank');
}}>{item?.consultation_data?.meeting_link}</span></td>
          

            
                      {/* <td>
                                  <UncontrolledDropdown>
                                    <DropdownToggle
                                      className="btn-icon-only text-light"
                                      role="button"
                                      size="sm"
                                      color=""
                                      // onClick={(e) => e.preventDefault()}
                                    >
                                      <i className="fas fa-ellipsis-v" />
                                    </DropdownToggle>
                                    <DropdownMenu
                                      className="dropdown-menu-arrow "
                                      right
                                    >
                                      <DropdownItem
                                        className="text-dark"
                                        //  onClick={() => toggleEditModal("Add3",item)}
                                        to={`/admin/viewenquiry`}
                                        tag={Link}
                                      >
                                        <i class="fa-solid fa-eye"></i>
                                        View
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={toggleModal1}
                                        className="text-dark"
                                      >
                                        Qualified
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={toggleModal1}
                                        className="text-dark"
                                      >
                                        Pending
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={toggleModal2}
                                        className="text-dark"
                                      >
                                        Disqualified
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </td> */}
                    </tr>
                    )
                  })}
                   
                    
                  </tbody>
                
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                   totalPages={parseInt(dataList?.meta?.total_page)}
                   currentPage={parseInt(dataList?.meta?.current_page)}
                   pageUrl="/admin/messages?"
                 /> */}
              </CardFooter>
            </Card>
          </div>
    </Container>
  )
}

export default Echlistdetail
